import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { AlrLogo } from "@/components/Brand";

export const AuthShell = ({ children, backTo = "/", backLabel = "Back to sign in" }) => (
  <div className="min-h-screen bg-[#0A0A0A] font-body text-white">
    <div className="alr-grain fixed inset-0 pointer-events-none" />
    <main className="relative mx-auto w-full max-w-lg px-5 py-10 sm:px-6">
      <div className="mb-8 flex items-center justify-between">
        <Link to={backTo} data-testid="auth-back-link" className="flex min-h-[44px] items-center gap-1 text-sm font-bold text-neutral-400 hover:text-white">
          <ChevronLeft size={18} /> {backLabel}
        </Link>
        <AlrLogo size={96} />
      </div>
      <div className="alr-rise rounded-2xl border border-[#333] bg-[#1A1A1A] p-6 sm:p-8">{children}</div>
    </main>
  </div>
);

export const PrimaryButton = ({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`mt-5 flex min-h-[48px] w-full items-center justify-center rounded-lg bg-[#4CCC06] py-4 text-[13px] font-extrabold tracking-[0.14em] text-black transition-opacity disabled:opacity-50 ${className}`}
  >
    {children}
  </button>
);

export const inputCls =
  "w-full rounded-lg border border-[#333] bg-[#121212] px-4 py-3.5 text-[15px] text-white placeholder:text-neutral-500 outline-none focus:border-[#4CCC06]";
